module.exports = __webpack_public_path__ + "static/img/normal.f48fed2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/detailpic/UC3880/normal.jpg
// module id = cokV
// module chunks = 51